var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdInputLimits } from "../../constants/IdInputLimits";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { DialogContent } from "../errors/DialogContent";
import { actionTrackingSendFeedback } from "../game-tracking/actionGameTracking";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var DialogFeedbackDOM = /** @class */ (function (_super) {
    __extends(DialogFeedbackDOM, _super);
    function DialogFeedbackDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.placeholder = utilLoca.get(IdLoca.feedbackDialog_input_web);
        _this.handleChange = function (e) {
            var feedbackMessage = e.currentTarget.value;
            var disableButton = feedbackMessage.length < 1;
            _this.setState({
                disableButton: disableButton,
                feedbackMessage: feedbackMessage,
            });
        };
        _this.submitMessage = function () {
            var feedbackMessage = _this.state.feedbackMessage;
            var onSubmitFeedback = _this.props.onSubmitFeedback;
            if (feedbackMessage.length > 0) {
                var completeFeedbackMessage = "WEB_" + feedbackMessage;
                onSubmitFeedback(completeFeedbackMessage);
            }
        };
        _this.state = {
            disableButton: true,
            feedbackMessage: "",
        };
        return _this;
    }
    DialogFeedbackDOM.prototype.render = function () {
        var _a = this.state, feedbackMessage = _a.feedbackMessage, disableButton = _a.disableButton;
        var onClose = this.props.onClose;
        return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.settingsMenu_feedback, className: IdStyles.ModalBackground, onClose: onClose },
            React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
                React.createElement(DialogContent, { messageLocaId: IdLoca.feedbackDialog_desc_web }),
                React.createElement("div", { className: "flex flex--guts flex--stacked flex__full w100" },
                    React.createElement("textarea", { value: feedbackMessage, className: IdStyles.TextNormal + " feedback-textarea", maxLength: IdInputLimits.CharLimitFeedback, placeholder: this.placeholder, onChange: this.handleChange })),
                React.createElement("div", { className: "button-ribbon" },
                    React.createElement(ButtonPrimary, { disabled: disableButton, onClick: this.submitMessage },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.send }))))));
    };
    return DialogFeedbackDOM;
}(React.Component));
var mapDispatch = function (dispatch) { return ({
    onClose: function () {
        dispatch(actionModalClose(IdModal.Feedback));
    },
    onSubmitFeedback: function (feedbackMessage) {
        dispatch(actionModalClose(IdModal.Feedback));
        dispatch(actionTrackingSendFeedback(feedbackMessage));
        dispatch(actionModalOpen(IdModal.FeedbackConfirmation));
    },
}); };
export var DialogFeedback = connect(undefined, mapDispatch)(DialogFeedbackDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/feedback/DialogFeedback.tsx
// module id = 2831
// module chunks = 3